<div class="card-body bg-white timesList">
    <div class="row">
        <div class="col-12">
            <!-- DataTable -->

            <div class="table-responsive ">
                <table class=" table mb-0 table-borderless">
                    <thead class="table-light">
                        <tr>
                            <th>{{ 'BOARD.TIMESLIST.STARTDATE' | translate }}</th>
                            <th>{{ 'BOARD.TIMESLIST.ENDDATE' | translate }}</th>
                            <th>{{ 'BOARD.TIMESLIST.USER' | translate }}</th>
                            <th class="text-center">{{ 'BOARD.TIMESLIST.TOTAL' | translate }}</th>
                            <th class="text-center">{{ 'BOARD.TIMESLIST.TOTALSUM' | translate }}</th>
                            <th class="optionsCustomized td-options-1">{{ 'BOARD.TIMESLIST.TYPE' | translate }}</th>
                            
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngIf="tableLoading">
                            <td [attr.colspan]="6" class="td-loading">
                                <div class="spinner-border"></div>
                            </td>
                        </tr>
                        <tr class="noDataTableMessage" *ngIf="!tableLoading && data.length == 0">
                            <td [attr.colspan]="6">
                                {{ 'PROJECTS.TABLE.EMPTY' | translate }}
                            </td>
                        </tr>
                        <tr *ngFor="let row of data">
                            <td>{{ row.start  | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            <td>{{ row.end  | date:'yyyy-MM-dd HH:mm:ss'}}</td>
                            <td>{{ row.user?.firstName}} {{ row.user?.lastName}}</td>
                            <td class="text-center">{{ parseSeconds(row.sum)}}</td>
                            <td class="text-center">{{ parseSeconds(row.accumulatedSum)}}</td>
                            <td class="optionsCustomized td-options-1">
                                <i *ngIf="row.isManuallyUpdated" class="mdi mdi-pencil" [title]="translate.instant('BOARD.TIMESLIST.EDIT')"></i>
                                <i *ngIf="!row.isManuallyUpdated" class="mdi mdi-timer" [title]="translate.instant('BOARD.TIMESLIST.COUNTER')"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="d-flex flex-wrap justify-content-center align-items-center justify-content-md-between mt-1 table-pagination"
                *ngIf="pagination">
                <div>
                    {{'DATATABLE.SHOWING' | translate}} {{startIndex }} {{'DATATABLE.TO' | translate}}
                    {{endIndex}} {{'DATATABLE.OF' | translate}} {{totalRecords}} {{'DATATABLE.ENTRIES' | translate}}
                </div>
                <ngb-pagination class="pagination-rounded custom-pagination" [collectionSize]="totalRecords"
                    [(page)]="page" [maxSize]="3" [boundaryLinks]="true" [pageSize]="pageSize"
                    (pageChange)="paginate()">
                </ngb-pagination>
            </div>
            <!-- end DataTable -->
        </div>
    </div>
</div>
